<template>
  <div class="box">
    <misc-tile v-for="misc in docs" :key="misc._id" :misc="misc"></misc-tile>
  </div>
</template>
<script>
import MiscTile from "./misc-tile";
export default {
  components: { MiscTile },
  computed: {
    docs() {
      let component = this;
      return component.$store.getters["misc/docs"];
    }
  },
  mounted() {
    let component = this;
    component.$store.dispatch("misc/index");
  }
};
</script>
